import { parseErrorMessage } from '../../../core/api/api.context';
import { ConfirmationModal } from '../../../ui/components/pure/modal-content/confirmation-modal.component';
import { useMutationDeleteCarrier } from '../carriers.queries';
import { CarrierModalProps } from './approve-carrier.modal';

export function DeleteCarrierModal({ carrier, onSuccess, onCancel }: CarrierModalProps) {
  const deleteMutation = useMutationDeleteCarrier();

  return (
    <ConfirmationModal
      title="Delete Carrier?"
      content={[carrier.name, 'Its couriers and delivery history are kept.']}
      warning="The carrier is also deleted in AC."
      isLoading={deleteMutation.isLoading}
      errorMessage={deleteMutation.error ? parseErrorMessage(deleteMutation.error.message) : undefined}
      onConfirm={() => deleteMutation.mutate(carrier.id, { onSuccess })}
      onCancel={onCancel}
      noteRequired={false}
      actionButton={{ label: 'Delete', color: 'danger' }}
      cancelButton={{ label: 'Cancel', color: 'secondary' }}
    />
  );
}
